import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../store";
import {
  fetchCustomPackages as fetchCustomPackagesThunk,
  selectCustomPackages,
  selectCustomPackagesLoading,
  selectCustomPackagesError,
  clearError,
} from "../store/slices/customPackage";

export const useCustomPackage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const packages = useSelector(selectCustomPackages);
  const loading = useSelector(selectCustomPackagesLoading);
  const error = useSelector(selectCustomPackagesError);

  const fetchCustomPackages = useCallback(() => {
    dispatch(fetchCustomPackagesThunk());
  }, [dispatch]);

  const clearPackageError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  return {
    packages,
    loading,
    error,
    fetchCustomPackages,
    clearPackageError,
  };
};
